import { supabase } from '../supabase'
import type { CreateGalaRsvpInput } from '@/lib/types/galaRsvp'

const GALA_DINNER_EVENT_KEY = 'gala_dinner_2026_03_29'

export const galaRsvpRepository = {
  async createRsvp(input: CreateGalaRsvpInput): Promise<void> {
    const { error } = await supabase
      .from('gala_dinner_rsvps')
      .insert({
        event_key: GALA_DINNER_EVENT_KEY,
        name: input.name,
        source: 'rsvp_site',
        status: 'attending',
      })

    if (error) {
      throw new Error(`Failed to submit RSVP: ${error.message}`)
    }
  },
}
